export const getDepartmentState = (state: any) => state.department;
